var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-navigation-drawer',{attrs:{"width":"100%","right":true,"absolute":"","touchless":"","temporary":""},model:{value:(_vm.showLog),callback:function ($$v) {_vm.showLog=$$v},expression:"showLog"}},[_c('MvWdAisaChat')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }